export default __webpack_public_path__ + "static/Matt-Kurleto-Neoteric-m-4c749b1fb89a040624125894ebad6ed2.jpg";